import {useQuery} from "react-query";
import api from "../api";

export const useGetAccount = () => {
    return useQuery(["account"], () => {
        return api.get("account").then((res) => res.data);
    });
}